@import 'styles/variables';

.starsRow {
  display: flex;
  align-items: center;
  gap: 6px;
}

.starsContainer {
  display: flex;
  align-items: center;
}

.starButton {
  all: unset;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.disabled {
    cursor: default;
  }
}

.feedbackContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 15px;
  padding-bottom: 0;
  border: 1px solid var(--dark-8);
  border-radius: 12px;
  background-color: var(--light-100);
}
